import { LogType } from "./base";
const config = {
  Dimens: {
    Dimen2Map: {
      collection: '"数据源模版"',
      collectionProduct: '"数据源模板(包含环境和版本功能)"',
      datasource: '"数据源接口"',
      db_datasource: '"数据源DB接口"',
      Gateway123: '"123网关功能"',
      projectDns: '"项目寻址信息管理"'
    },
    Dimen3Map: {
      get: '信息查询服务(查询单条数据的详情)',
      update: '数据更新服务(更新指定ID的数据)',
      basicList: '基础列表服务(获取多条数据)',
      runtime_request: '运行时请求接口，调用数据源配置的远端服务',
      debugHandler: '单接口调试服务',
      debugPreview: '接口调试前二次确认查询',
      listCgiAdaptor: '接口实例列表服务(查询多条当前项目可复用的接口实例)',
      frontEndHttp: '前端数据源接口'
    },
    Dimen45Map: {
      descriptor_input: '内容为接口的原始输入',
      descriptor_output: '内容为接口的最终输出',
      savePreviewImage_output: '',
      cgiInfo_config: '用Anode发起Rpc调用普通Http接口，输入到Anode的配置内容',
      cgiInfo_result: 'Http接口调用成功，返回内容包含接口的数据，耗时，回源路径等',
      cgiInfo_dnsInfo: 'Http接口的寻址信息，包含寻址类型和具体的寻址数据',
      sql_config: '调用SQL调用的配置内容',
      sql_result: '调用SQL调用成功，返回内容包含接口的数据，耗时，SQL等',
      cgiInfoScf_config: '即将调用配置的云函数，获取当前云函数的详细信息',
      cgiInfoScf_result: '内容为云函数的调用结果',
      cgiInfoGw123_config: '即将调用123平台的网关接口，先获取配置的网关信息',
      cgiInfoGw123_result: '内容为123网关接口的调用结果',
      CgiRemoteWuji_config: '即将调用配置的远程数据表，获取当前远程数据表的详细信息',
      CgiRemoteWuji_result: '内容为远程数据表的调用结果',
      modules_cgiInfo: '内容为获取到的接口配置',
      modules_cacheKeyPluginCode: '检测到当前接口存在自定义缓存Key的插件，内容为插件代码',
      modules_cacheKeyPluginResult: '自定义缓存Key的插件运行结果',
      modules_cacheKey: '内容为接口的缓存Key',
      modules_cgiPlugin: '检测到当前接口有安装前置插件，内容为该插件信息与运行结果',
      modules_passResHeaders: '内容为透传的响应头',
      api_cgiAdaptor: '从输入配置中生成的CgiAdaptor实例',
      api_dbCgiInfo: '根据配置生成的DB类型接口实例',
      api_config: '内容为远程数据表接口配置',
      api_output: '内容为请求响应完整结果',
      hook_result: '经过转发规则之后的请求参数和响应结果',
      DBHook_result: 'DB数据源经过转发之后的请求参数与响应结果',
      customDescription: '该日志为业务逻辑上报，仅能展示维度原始信息，无注释',
      setHttpParams_params: '前端HTTP请求配置,内容为用户传入参数',
      httpRequest_config: '开始请求数据源接口,内容为请求配置',
      httpResponse_result: '计算最后返回结果,内容为最终返回结果',
      beforeHook_config: '前置执行脚本,内容为改写后的请求配置',
      afterHook_result: '后置执行脚本,内容为返回的结果',
      httpRequestError_error: '请求失败，内容为错误信息'
    },
    briefDimen45Info: {
      descriptor_input: '请求参数',
      descriptor_output: '最终响应',
      savePreviewImage_output: '页面快照上传结果',
      cgiInfo_config: 'Http类型数据源后端请求配置',
      cgiInfo_result: 'Http类型数据源后端响应结果',
      cgiInfoScf_config: '云函数请求配置',
      cgiInfoScf_result: '云函数后端响应结果',
      cgiInfoGw123_config: '123网关配置信息',
      cgiInfoGw123_result: '123网关接口响应结果',
      CgiRemoteWuji_config: '远程数据表请求配置',
      CgiRemoteWuji_result: '远程数据表响应结果',
      modules_cgiInfo: '接口配置',
      modules_cgiPlugin: '插件配置与运行结果',
      modules_passResHeaders: '响应头',
      api_cgiAdaptor: '接口实例信息',
      api_dbCgiInfo: 'db接口实例信息',
      api_config: '远程数据表接口配置',
      api_output: '接口输出结果',
      hook_result: '后端响应结果',
      DBHook_result: 'DB类型数据源后端响应结果',
      setHttpParams_params: '前端HTTP请求配置',
      httpRequest_config: '请求配置',
      httpResponse_result: '最终返回结果',
      beforeHook_config: '前置执行脚本',
      afterHook_result: '后置执行脚本',
      httpRequestError_error: '出错'
    }
  },
  LogTypes: [LogType.All, {
    value: 1,
    label: '运行时日志',
    condition: ['dimen3', '=', 'runtime_request']
  }, {
    value: 2,
    label: '操作日志',
    condition: ['dimen3', '!=', 'runtime_request']
  }]
};
export default config;
//# sourceMappingURL=wujiDs.js.map
